import * as React from 'react';

function PokerFill(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.506 19.306l6.846-1.826c.67-.178 1.065-.849.88-1.496l-3.1-10.826 4.796.859c.682.096 1.156.73 1.06 1.414L19.26 19.67a1.248 1.248 0 01-1.41 1.063l-7.466-1.35.122-.078z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.913 19.288l8.679-2.315c.67-.178 1.064-.849.88-1.496L14.154 3.892c-.185-.646-.88-1.027-1.55-.848L3.924 5.36c-.67.178-1.064.849-.88 1.496l3.317 11.584c.185.648.88 1.028 1.55.849zm4.054-7.449l-.958-1.325 1.01-1.29-1.601.471-.958-1.327-.03 1.617-1.603.471 1.582.528-.031 1.616 1.008-1.29 1.581.529zm-3.08-5.29s.96.478 2.475 1.258c.799.412 2.639 1.476 3.099 2.935.306.974-.263 2.003-1.27 2.299-.661.195-1.144-.011-1.824-.391 0 0-.108-.044-.165-.027-.095.028-.161.117-.126.194.236.504.948 1.707 2.292 1.79l-3.56 1.047c1.069-.791.967-2.175.873-2.721-.016-.082-.12-.12-.215-.094-.06.018-.122.111-.122.111-.315.815-.63 1.113-1.29 1.307-1.009.297-2.073-.252-2.38-1.225-.46-1.46.456-3.334.883-4.106.807-1.463 1.33-2.377 1.33-2.377z"
        fill="currentColor"
      />
    </svg>
  );
}
export default PokerFill;
